// Types
import { ThemeOptions, Theme } from "@mui/material";

// Options
import defaultPalette from "./palette";
import breakpoints from "./breakpoints";
import typography from "./typography";
import spacing from "./spacing";
import overrides from "./overrides";
import shadows from "./shadows";

const themeOptions = (theme: Theme): ThemeOptions => {
  const options: ThemeOptions = {
    palette: defaultPalette(theme),
    shape: {
      borderRadius: 6,
    },
    breakpoints: breakpoints(),
    typography,
    ...spacing,
    components: overrides(),
    custom: {
      sidebarWidth: 280,
      mobileSidebarWidth: 240,
      desktopSidebarWidth: 280,
    },
    shadows: shadows(),
  };

  return options;
};

export default themeOptions;
